import { render, staticRenderFns } from "./inquiryNew.vue?vue&type=template&id=28f33612&scoped=true&"
import script from "./inquiryNew.vue?vue&type=script&lang=js&"
export * from "./inquiryNew.vue?vue&type=script&lang=js&"
import style0 from "./inquiryNew.vue?vue&type=style&index=0&id=28f33612&lang=scss&scoped=true&"
import style1 from "./inquiryNew.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./inquiryNew.vue?vue&type=style&index=2&id=28f33612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f33612",
  null
  
)

export default component.exports